<div class="container">
  <div class="title-container">
    <h2>Web Projects</h2>
  </div>

  <div class="works-list">
    <div class="works-container">
      <ng-container *ngFor="let work of this.worksList">
        <a class="work-card" href="" routerLink='project' [queryParams]="{ id: work.id }">
          <div class="works-info_container">
            <div class="works-info top" >
              <div class="catagory-container">
                <h3 *ngIf="work.category === 'web'">
                  Web Development
                </h3>

                <h3 *ngIf="work.category === 'graphic'">
                  Graphic Design
                </h3>

                <h3 *ngIf="work.category === 'app'">
                  Mobile App
                </h3>

                <h3 *ngIf="work.category === 'video'">
                  Video Production
                </h3>

                <h3 *ngIf="work.category === 'photo'">
                  Photography
                </h3>

                <h3 *ngIf="work.category === 'misc'">
                  Misc
                </h3>

                <h3 *ngIf="work.category === 'research'">
                  Research
                </h3>
              </div>

              <div class="external-link-container">
                <ng-container *ngIf="work.github">
                  <a href="https://github.com/{{ work.github }}" target="_blank" (click)="$event.stopPropagation()" rel="noopener noreferrer">
                    <svg class="github logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 438.549 438.549" xml:space="preserve">
                <path d="M409.132,114.573c-19.608-33.596-46.205-60.194-79.798-79.8C295.736,15.166,259.057,5.365,219.271,5.365c-39.781,0-76.472,9.804-110.063,29.408c-33.596,19.605-60.192,46.204-79.8,79.8C9.803,148.168,0,184.854,0,224.63c0,47.78,13.94,90.745,41.827,128.906c27.884,38.164,63.906,64.572,108.063,79.227c5.14,0.954,8.945,0.283,11.419-1.996c2.475-2.282,3.711-5.14,3.711-8.562c0-0.571-0.049-5.708-0.144-15.417c-0.098-9.709-0.144-18.179-0.144-25.406l-6.567,1.136c-4.187,0.767-9.469,1.092-15.846,1c-6.374-0.089-12.991-0.757-19.842-1.999c-6.854-1.231-13.229-4.086-19.13-8.559c-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559c-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-0.951-2.568-2.098-3.711-3.429c-1.142-1.331-1.997-2.663-2.568-3.997c-0.572-1.335-0.098-2.43,1.427-3.289c1.525-0.859,4.281-1.276,8.28-1.276l5.708,0.853c3.807,0.763,8.516,3.042,14.133,6.851c5.614,3.806,10.229,8.754,13.846,14.842c4.38,7.806,9.657,13.754,15.846,17.847c6.184,4.093,12.419,6.136,18.699,6.136c6.28,0,11.704-0.476,16.274-1.423c4.565-0.952,8.848-2.383,12.847-4.285c1.713-12.758,6.377-22.559,13.988-29.41c-10.848-1.14-20.601-2.857-29.264-5.14c-8.658-2.286-17.605-5.996-26.835-11.14c-9.235-5.137-16.896-11.516-22.985-19.126c-6.09-7.614-11.088-17.61-14.987-29.979c-3.901-12.374-5.852-26.648-5.852-42.826c0-23.035,7.52-42.637,22.557-58.817c-7.044-17.318-6.379-36.732,1.997-58.24c5.52-1.715,13.706-0.428,24.554,3.853c10.85,4.283,18.794,7.952,23.84,10.994c5.046,3.041,9.089,5.618,12.135,7.708c17.705-4.947,35.976-7.421,54.818-7.421s37.117,2.474,54.823,7.421l10.849-6.849c7.419-4.57,16.18-8.758,26.262-12.565c10.088-3.805,17.802-4.853,23.134-3.138c8.562,21.509,9.325,40.922,2.279,58.24c15.036,16.18,22.559,35.787,22.559,58.817c0,16.178-1.958,30.497-5.853,42.966c-3.9,12.471-8.941,22.457-15.125,29.979c-6.191,7.521-13.901,13.85-23.131,18.986c-9.232,5.14-18.182,8.85-26.84,11.136c-8.662,2.286-18.415,4.004-29.263,5.146c9.894,8.562,14.842,22.077,14.842,40.539v60.237c0,3.422,1.19,6.279,3.572,8.562c2.379,2.279,6.136,2.95,11.276,1.995c44.163-14.653,80.185-41.062,108.068-79.226c27.88-38.161,41.825-81.126,41.825-128.906C438.536,184.851,428.728,148.168,409.132,114.573z"/>
              </svg>
                  </a>
                </ng-container>
                <ng-container *ngIf="work.website">
                  <a *ngIf="work.category === 'web'" href="https://{{ work.website }}" target="_blank" (click)="$event.stopPropagation()" rel="noopener noreferrer">
                    <svg class="website logo" viewBox="0 0 100 100" xml:space="preserve">
                  <g><g>
                      <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"></path>
                      <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"></path>
                      <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"></path>
                      <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"></path>
                    </g><path d="M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M60.2,27.2    c-3.3,0.6-6.7,0.9-10.2,0.9c-3.5,0-6.9-0.3-10.2-0.9C42.4,15.4,46.7,8.4,50,8.4S57.6,15.4,60.2,27.2z M60.1,9.7    c7.2,1.8,13.7,5.5,18.9,10.6c-3.8,2.4-8.2,4.3-13,5.6C64.6,19.5,62.6,13.9,60.1,9.7z M37.6,47c0.1-5.1,0.5-9.8,1.2-14    c3.7,0.6,7.4,1,11.3,1c3.8,0,7.6-0.4,11.3-1c0.6,4.2,1,8.9,1.2,14H37.6z M62.4,53c-0.1,5.1-0.5,9.8-1.1,14c-3.7-0.6-7.4-1-11.3-1    c-3.8,0-7.6,0.4-11.3,1c-0.6-4.2-1-8.9-1.1-14H62.4z M34,25.9c-4.8-1.3-9.2-3.2-13-5.6c5.2-5.1,11.7-8.7,18.9-10.6    C37.4,13.9,35.4,19.5,34,25.9z M33,31.8c-0.8,4.9-1.2,10.1-1.3,15.3h-23c0.6-8.3,3.7-16,8.5-22.3C21.6,27.8,27.1,30.2,33,31.8z     M31.6,53c0.1,5.2,0.6,10.3,1.3,15.3c-5.9,1.6-11.3,3.9-15.9,7C12.2,69,9.2,61.3,8.6,53H31.6z M34,74.1c1.4,6.4,3.4,12.1,5.9,16.2    c-7.2-1.8-13.7-5.5-18.9-10.6C24.8,77.3,29.2,75.4,34,74.1z M39.8,72.8c3.3-0.6,6.7-0.9,10.2-0.9c3.5,0,6.9,0.3,10.2,0.9    C57.6,84.6,53.3,91.6,50,91.6S42.4,84.6,39.8,72.8z M66,74.1c4.8,1.3,9.2,3.2,13,5.7c-5.2,5.1-11.7,8.7-18.9,10.6    C62.6,86.1,64.6,80.5,66,74.1z M67,68.2c0.8-4.9,1.2-10.1,1.3-15.3h23c-0.6,8.3-3.7,16-8.5,22.3C78.3,72.2,72.9,69.8,67,68.2z     M68.4,47c-0.1-5.2-0.6-10.3-1.3-15.3c5.9-1.6,11.3-3.9,15.9-7c4.8,6.3,7.9,13.9,8.5,22.3H68.4z"></path></g>
              </svg>
                  </a>

                  <a *ngIf="work.category === 'research'" href="https://{{ work.website }}" target="_blank" (click)="$event.stopPropagation()" rel="noopener noreferrer">
                    <svg class="website logo" viewBox="0 0 100 100">
                      <path d="M76.5,15.7L62.2,1.5c-0.2-0.2-0.5-0.3-0.8-0.3h-53c-0.6,0-1.2,0.5-1.2,1.2v85.4c0,0.6,0.5,1.2,1.2,1.2h39  c0.6,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2H9.6V3.5h50.6v14.3h14.3v35.4c0,0.6,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V16.6  C76.8,16.3,76.7,16,76.5,15.7z M62.6,5.1l10.3,10.3H62.6V5.1z"></path>
                      <path d="M71.9,98.9c-11.6,0-21-9.4-21-21s9.4-21,21-21c11.6,0,21,9.4,21,21S83.4,98.9,71.9,98.9z M71.9,59.2  c-10.3,0-18.7,8.4-18.7,18.7c0,10.3,8.4,18.7,18.7,18.7s18.7-8.4,18.7-18.7C90.5,67.6,82.1,59.2,71.9,59.2z"></path>
                      <path d="M65.7,27.1H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2  C66.9,26.6,66.3,27.1,65.7,27.1z"></path>
                      <path d="M65.7,44.7H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,44.7,65.7,44.7z"></path>
                      <path d="M65.7,53.5H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,53.5,65.7,53.5z"></path>
                      <path d="M65.7,35.9H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,35.9,65.7,35.9z"></path>
                      <path d="M51,62.3H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2H51c0.6,0,1.2,0.5,1.2,1.2  C52.2,61.8,51.7,62.3,51,62.3z"></path>
                      <path d="M42,71.1H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2H42c0.6,0,1.2,0.5,1.2,1.2  C43.2,70.6,42.7,71.1,42,71.1z"></path>
                      <path d="M77.8,79.3c-0.5-0.5-1.2-0.5-1.7,0l-2.8,2.8V70.8c0-0.7-0.5-1.2-1.2-1.2S71,70.1,71,70.8v11.3l-2.8-2.8  c-0.5-0.5-1.2-0.5-1.7,0c-0.5,0.5-0.5,1.2,0,1.7l4.8,4.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l4.8-4.8  C78.3,80.5,78.3,79.8,77.8,79.3z"></path>
                    </svg>
                  </a>

                  <a *ngIf="work.category === 'app'" href="https://{{ work.website }}" target="_blank" (click)="$event.stopPropagation()" rel="noopener noreferrer">
                    <svg class="website logo" viewBox="0 0 100 100">
                      <path d="M76.5,15.7L62.2,1.5c-0.2-0.2-0.5-0.3-0.8-0.3h-53c-0.6,0-1.2,0.5-1.2,1.2v85.4c0,0.6,0.5,1.2,1.2,1.2h39  c0.6,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2H9.6V3.5h50.6v14.3h14.3v35.4c0,0.6,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V16.6  C76.8,16.3,76.7,16,76.5,15.7z M62.6,5.1l10.3,10.3H62.6V5.1z"></path>
                      <path d="M71.9,98.9c-11.6,0-21-9.4-21-21s9.4-21,21-21c11.6,0,21,9.4,21,21S83.4,98.9,71.9,98.9z M71.9,59.2  c-10.3,0-18.7,8.4-18.7,18.7c0,10.3,8.4,18.7,18.7,18.7s18.7-8.4,18.7-18.7C90.5,67.6,82.1,59.2,71.9,59.2z"></path>
                      <path d="M65.7,27.1H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2  C66.9,26.6,66.3,27.1,65.7,27.1z"></path>
                      <path d="M65.7,44.7H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,44.7,65.7,44.7z"></path>
                      <path d="M65.7,53.5H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,53.5,65.7,53.5z"></path>
                      <path d="M65.7,35.9H18.4c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h47.3c0.6,0,1.2,0.5,1.2,1.2S66.3,35.9,65.7,35.9z"></path>
                      <path d="M51,62.3H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2H51c0.6,0,1.2,0.5,1.2,1.2  C52.2,61.8,51.7,62.3,51,62.3z"></path>
                      <path d="M42,71.1H18.4c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2H42c0.6,0,1.2,0.5,1.2,1.2  C43.2,70.6,42.7,71.1,42,71.1z"></path>
                      <path d="M77.8,79.3c-0.5-0.5-1.2-0.5-1.7,0l-2.8,2.8V70.8c0-0.7-0.5-1.2-1.2-1.2S71,70.1,71,70.8v11.3l-2.8-2.8  c-0.5-0.5-1.2-0.5-1.7,0c-0.5,0.5-0.5,1.2,0,1.7l4.8,4.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l4.8-4.8  C78.3,80.5,78.3,79.8,77.8,79.3z"></path>
                    </svg>
                  </a>
                </ng-container>
              </div>
            </div>

            <div class="works-info bottom">
              <span class="works-title">{{ work.title }}</span>

              <div class="works-tags">
                <ng-container *ngIf="work.tags?.split(',').includes('react')">
                  <a href="https://react.dev/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/react-1.png" alt="React Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('html')">
                  <a href="https://developer.mozilla.org/en-US/docs/Web/HTML" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/html.png" alt="HTML Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('css')">
                  <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/css.png" alt="CSS Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('javascript')">
                  <a href="https://developer.mozilla.org/en-US/docs/Web/javascript" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/javascript.png" alt="Javascript Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('xml')">
                  <a href="https://developer.mozilla.org/en-US/docs/Web/XML/XML_introduction" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/xml.png" alt="XML Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('scss')">
                  <a href="https://sass-lang.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/scss.png" alt="SCSS Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('typescript')">
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/typescript.png" alt="TypeScript Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('java,')">
                  <a href="https://docs.oracle.com/javase/7/docs/api/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/java.png" alt="Java Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('c++')">
                  <a href="https://docs.microsoft.com/en-us/cpp/?view=vs-2019" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/c++.png" alt="C++ Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('c#')">
                  <a href="https://docs.microsoft.com/en-us/dotnet/csharp/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/csharp.png" alt="C# Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('opencv')">
                  <a href="https://docs.opencv.org/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/opencv.png" alt="OpenCV Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('mips32')">
                  <a href="https://www.mips.com/products/architectures/mips32-2/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/mips32.png" alt="MIPS32 Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('rainmeter')">
                  <a href="https://docs.rainmeter.net/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/rainmeter.png" alt="Rainmeter Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('django')">
                  <a href="https://www.djangoproject.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/django.png" alt="Django Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('asp.net')">
                  <a href="https://dotnet.microsoft.com/apps/aspnet" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/aspnet.png" alt="Asp.net Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('node')">
                  <a href="https://nodejs.org/en/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/node.png" alt="Node JS Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('postgre')">
                  <a href="https://www.postgresql.org/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/postgre.png" alt="Postgre SQL Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('t-sql')">
                  <a href="https://docs.microsoft.com/en-us/sql/t-sql/tutorial-writing-transact-sql-statements?view=sql-server-ver15" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/tsql.png" alt="Transact-SQL Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('mysql')">
                  <a href="https://www.mysql.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/mysql.png" alt="MySQL Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('android')">
                  <a href="https://developer.android.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/android.png" alt="Android Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('photoshop')">
                  <a href="https://www.adobe.com/products/photoshop.html" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/photoshop.png" alt="Photoshop Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('after effects')">
                  <a href="https://www.adobe.com/products/aftereffects.html" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/ae.png" alt="After Effects Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('premiere pro')">
                  <a href="https://www.adobe.com/products/premiere.html" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/premiere.png" alt="Premiere Pro Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('cinema 4d')">
                  <a href="https://www.maxon.net/en-us/products/cinema-4d/overview/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/cinema.png" alt="Cinema 4d Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('unity')">
                  <a href="https://docs.unity3d.com/Manual/index.html" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/unity.png" alt="Unity Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('XD')">
                  <a href="https://www.adobe.com/products/xd.html" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/xd.png" alt="XD Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('shopify')">
                  <a href="https://www.shopify.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/shopify-logo.png" alt="Shopify Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('php')">
                  <a href="https://www.php.net/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/php.png" alt="PHP Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('figma')">
                  <a href="https://www.figma.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/figma.png" alt="Figma Icon">
                  </a>
                </ng-container>
                <ng-container *ngIf="work.tags?.split(',').includes('python')">
                  <a href="https://www.python.org/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                    <img src="assets/tag-icons/python.png" alt="Python Icon">
                  </a>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="loading-logo_container">
            <div #image_loader class="loading-logo"></div>
          </div>

          <picture>
            <img
              class="thumbnail"
              src="{{ work.thumbnail_src.url }}"
              alt="{{ work.thumbnail_src.alt ? work.thumbnail_src.alt : work.title + ' thumbnail image' }}"
            >
          </picture>
        </a>
      </ng-container>
    </div>
  </div>

  <not-found *ngIf="emptyProjects"></not-found>

  <swiper-toolbox></swiper-toolbox>

  <links
    [contact]="true"
    [projects]="false"
    [about]="true"
  ></links>
</div>




